<template>
    <div class="reviews-average-ratings">
        <div class="h4 mb-1 pb-0">
            {{ subtitle }}
        </div>
        <div v-for="(averageRating, index) in averageRatings" :key="index" class="row align-items-center">
            <p class="col-6 d-md-none mb-0 pe-0" v-html="averageRating.label" />
            <ob1-rating
                class="col-6 d-md-none ps-0"
                :average="averageRating.value"
                :rating-results-height="1.25"
                :with-score="true"
            />
            <p class="col-md-5 d-none d-md-block mb-0 pe-0" v-html="averageRating.label" />
            <ob1-rating
                class="col-md-7 d-none d-md-block"
                :average="averageRating.value"
                :rating-results-height="1.375"
                :with-score="true"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        averageRatings: {
            type: Array,
            required: true
        },
        subtitle: {
            type: String,
            required: true,
        }
    }
}
</script>

<style scoped lang="scss">
@import 'ob1_common';
@import 'ob1_variables';

.reviews-average-ratings {
    @media (min-width: #{map-get($grid-breakpoints, xs)}) {
        min-width: px-to-rem(300);
        max-width: px-to-rem(300);
    }
    @media (min-width: #{map-get($grid-breakpoints, md)}) {
        min-width: px-to-rem(320);
        max-width: px-to-rem(320);
    }
    @media (min-width: #{map-get($grid-breakpoints, lg)}) {
        min-width: px-to-rem(349);
        max-width: px-to-rem(349);
    }
}
</style>
